import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=286b7bb8&scoped=true&"
import script from "./Subjects.vue?vue&type=script&lang=ts&"
export * from "./Subjects.vue?vue&type=script&lang=ts&"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=286b7bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b7bb8",
  null
  
)

export default component.exports